<template lang="html">
    <div class="dropdown user-dropdown">
        <button @click="showUserMenu = !showUserMenu" class="dropdown-open">
            <div class="c__user">
                Welcome, <span>{{ getUser }}!</span>
            </div>
        </button>
        <transition name="fade">
            <dropdown-menu placement="right" :open.sync="showUserMenu">
                <button class="dropdown-item" @click="goToPreference">Preferences</button>
                <button class="dropdown-item" @click="logout">Logout</button>
            </dropdown-menu>
        </transition>
    </div>
</template>

<script>
    import DropdownMenu from '../../helpers/DropdownMenu';
    import store from '../../store/index.js';
    import NavigationPerimeters from '../../configs/Perimeters/navigation';

    export default {
        perimeters: [NavigationPerimeters],
        components: {
            DropdownMenu,
        },
        computed: {
            getUser (){
                return store.state.welcomeMsg;
            }
        },
        data () {
            return {
                showUserMenu: false,
            }
        },
        created: function() {
            let self = this;
            window.addEventListener('click', function(e){
                if (!self.$el.contains(e.target)){
                    self.showUserMenu = false
                }
            })
        },
        methods: {
            canViewClients(){
                return NavigationPerimeters.isAllowed('viewClients');
            },
            isActiveRoute (activeRoutes) {
                return  activeRoutes.includes(this.$route.name);
            },
            goToPreference(){
                this.$router.push('/preferences');
            },
            logout() {
                this.$store.dispatch('logout').then(() => {
                    this.$router.push('/login');
                }).catch(() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                });
            }
        },
    }

</script>

